import { HttpClient, HttpHeaders } from '@angular/common/http';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { WidgetAuthErrorEnum } from './models/widget-auth-error.enum';
import { UserAnalyticModel } from './models/user-analytic.model';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
const formHeaders = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8'
    })
};
export class WidgetAnalyticsService {
    constructor(http) {
        this.http = http;
    }
    /**
     * Validates the specified analytic id.
     */
    getAnalytic(analyticId) {
        return this.http.get(`/ws/user/analytics?analytic_id=${analyticId}`)
            .pipe(map(() => ({ success: true })), catchError((response) => of(this.parseError(response))));
    }
    /**
     * Sends an analytic and return the validation status.
     */
    sendAnalytic(analytic) {
        const request$ = analytic instanceof UserAnalyticModel
            // user analytic
            ? this.http.post(`/ws/user/analytics`, analytic, formHeaders)
            // developer analytic
            : this.http.post(`/ws/developer/apps/access/key`, analytic, formHeaders);
        return request$
            .pipe(map(() => ({ success: true })), catchError((response) => of(this.parseError(response))));
    }
    parseError(response) {
        const error = response.error.error;
        const status = response.status;
        // server error isn't an auth failure
        const success = status >= 500 && status <= 504;
        const message = error && error.message ? error.message : '';
        const errorCode = Object.values(WidgetAuthErrorEnum).includes(message) ? message : null;
        return { success: success, message: message, errorCode: errorCode };
    }
}
WidgetAnalyticsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function WidgetAnalyticsService_Factory() { return new WidgetAnalyticsService(i0.ɵɵinject(i1.HttpClient)); }, token: WidgetAnalyticsService, providedIn: "root" });
